export const classNames = {
  enter: '__enter',
  enterActive: '__enterActive',
  exit: '__exit',
  exitActive: '__exitActive'
}
